module.exports = __webpack_public_path__ + "static/media/loading_spin.6ce4f675.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading_spin.svg
// module id = 511
// module chunks = 0